<template>
  <div class="payment-success-page">
    <div class="mt-5" v-if="$route.query.rescode == '1' || $route.query.rescode == '2'">
      <img src="@/assets/img/completed.png" alt="" />
      <p class="payment-success-message" >
        Thanh toán thành công!!!<br />
        Hợp đồng {{$route.query.custcode}} đã thanh toán thành công số tiền {{Number($route.query.amount).toLocaleString()}} VND.
      </p>
      <div class="block md:flex justify-center">
        <router-link class="primary-button" :to="{ name: 'loanSummary' }" >
          Về trang chủ
        </router-link>
      </div>
    </div>
    <div class="mt-5" v-else>
      <img src="@/assets/img/failed.png" alt="" width="250px" height="200px"/>
      <p class="payment-success-message">
        Thanh toán thất bại!!! <br />
        Vui lòng thử lại hoặc liên hệ chăm sóc khách hàng để được hỗ trợ.
      </p>
      <div class="block md:flex justify-center">
        <router-link class="primary-button" :to="{ name: 'loanSummary' }" >
          Về trang chủ
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>

import { PaymentSummaryService } from '@/services/paymentSummary.service'

export default {
  name: 'PaymentResult',
  async created () {
    const self = this
    await PaymentSummaryService.verifyPaymentResult({
      Id: self.$route.query.txid,
      LoanNo: self.$route.query.custcode,
      PaymentAmount: self.$route.query.amount,
      PaymentStatus: self.$route.query.rescode,
      CheckSum: self.$route.query.checksum
    }).then((result) => {
      console.log(result)
    })
  }
}
</script>
